import React, {Component, useState, useEffect} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import CareersContent from '../components/CareersContent'; 
import axios from 'axios'; 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';

class Careers extends React.Component{

    
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div>
                <Header/>
                <Helmet>
                    <title>{metas[10].title}</title>  
                    <meta name="description" content={metas[10].meta_description} />
                    <meta name="keywords" content={metas[10].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'careers'} />
                </Helmet>  
                <PageHeader title="Careers" />
                <CareersContent content={JSON.parse(localStorage.getItem("content"))} careers={JSON.parse(localStorage.getItem("careers"))}  />  
                <Footer/>
      
        
        </div>
       
        )
    }

}
export default withRouter(Careers);;